<div class="searchResults mx-2-5 mb-2 pb-2rem">
    <div class="glossary_term_usage_heading">{{termUsageTitle}}</div>
    <div class="mt-1rem mb-1">{{termUsageDef}}</div>
    <div class="glossary_term_usage_heading fs-1-5rem pt-1"  tabindex="0" [innerHTML]="termData.name">
    </div>
    <div *ngIf="termData?.topic?.length>0">
      <div *ngFor="let term of termData.topic" class="mt_1 link-topic">
        <a *ngIf="term.paraType!='GLOSSTERM'" class="link mt-1rem display-list glossaryUsage searchTopicText font-16" (contextmenu)="onRightClick($event, term)" (mouseover)="mouseOverFunctions($event, term)" 
         (click)="navigateToContent($event, term)" (keyup.enter)="navigateToContent($event,  term)" tabindex="0">
            {{term.levelOne}} > {{term.levelTwo}} > {{term.levelThree}} > {{term.levelFour}} 
          <span *ngIf="(term.levelFive && term.levelFive==term.paraNumber)"> >&nbsp;
            <span *ngIf="(term.paraType=='FOOTNOTE') && term.levelFive">fn</span>
            <span *ngIf="(term.paraType=='PARA' || term.paraType=='p-norm') && term.levelFive">¶</span>
            <span *ngIf="(term.paraType=='QUESTION' && term.levelOne=='Codification') && term.levelFive">.</span>
            <span *ngIf="(term.paraType=='QUESTION' && term.levelOne!='Codification') && term.levelFive">Q</span>
            <span *ngIf="term.levelFive">{{term.levelFive}}</span>
          </span>
            <span *ngIf="(term.paraNumber && term.levelFive!=term.paraNumber)">
              >&nbsp;
              <span *ngIf="(term.paraType=='FOOTNOTE') && term.paraNumber">fn</span>
              <span *ngIf="(term.paraType=='PARA' || term.paraType=='p-norm') && term.paraNumber">¶</span>
              <span *ngIf="(term.paraType=='QUESTION' && term.levelOne=='Codification') && term.paraNumber">.</span>
              <span *ngIf="(term.paraType=='QUESTION' && term.levelOne!='Codification') && term.paraNumber">Q</span>
              <span *ngIf="term.paraNumber">{{term.paraNumber}}</span>
            </span>
          </a>
          <a *ngIf="term.paraType=='GLOSSTERM'" class="link mt-1rem display-list glossaryUsage searchTopicText font-16" id="{{term.paragraphId}}" (click)="OpenInlineGlossary($event)">
            <span *ngIf="term.levelOne=='gasb_glossaries'" id="{{term.paragraphId}}">
              <span *ngIf="term.levelTwo=='COD'">Codification</span>
              <span *ngIf="term.levelTwo=='OP'">Original Pronouncements</span>
              <span *ngIf="term.levelTwo=='CIG'">Comprehensive Implementation Guide</span>
              <span *ngIf="term.levelTwo!='COD' && term.levelTwo!='OP' && term.levelTwo!='CIG'">{{term.levelTwo}}</span>
              <span *ngIf="term.levelThree!=term.paraNumber"> > {{term.levelThree}} > {{term.paraNumber}}</span>
              <span *ngIf="term.levelThree==term.paraNumber"> > {{term.paraNumber}}</span>
            </span>
            <span *ngIf="term.levelOne!='gasb_glossaries'" id="{{term.paragraphId}}">{{term.levelOne}} > {{term.levelTwo}} > {{term.paraNumber}}</span>
          </a>
      </div>
    </div>
    <div *ngIf="termData?.length==0" class="pt-1-25">
      No Records Found.
    </div>
  </div>
